import { __decorate } from 'tslib';
import { ElementRef, NgZone, ChangeDetectorRef, Input, ViewChild, Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { merge, fromEvent } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/menu';
import * as ɵngcc3 from '@angular/material/divider';

const _c0 = ["testBed"];
const _c1 = ["everything"];
const _c2 = ["menuButtonReference"];
function ResponsiveToolbarComponent_ng_container_5_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_5_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r8);
} }
function ResponsiveToolbarComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_5_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r8);
} }
function ResponsiveToolbarComponent_ng_container_7_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_7_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r13);
} }
function ResponsiveToolbarComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r13);
} }
function ResponsiveToolbarComponent_ng_container_9_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_9_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r17);
} }
function ResponsiveToolbarComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_9_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", button_r17);
} }
function ResponsiveToolbarComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_13_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_13_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_13_div_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r23 = ɵngcc0.ɵɵreference(4);
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r23);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.menuButton);
} }
function ResponsiveToolbarComponent_ng_container_13_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_13_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_13_div_2_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r22.menuButton);
} }
function ResponsiveToolbarComponent_ng_container_13_ng_container_5_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveToolbarComponent_ng_container_13_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_13_ng_container_5_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r30 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", button_r30);
} }
function ResponsiveToolbarComponent_ng_container_13_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_13_ng_container_5_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelement(2, "mat-divider");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r27 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r27.items);
} }
function ResponsiveToolbarComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveToolbarComponent_ng_container_13_div_1_Template, 2, 2, "div", 12);
    ɵngcc0.ɵɵtemplate(2, ResponsiveToolbarComponent_ng_container_13_div_2_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementStart(3, "mat-menu", 14, 15);
    ɵngcc0.ɵɵtemplate(5, ResponsiveToolbarComponent_ng_container_13_ng_container_5_Template, 3, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.menuButtonEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.menuButtonEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r7.menuClass)("yPosition", ctx_r7.menuYPosition)("xPosition", ctx_r7.menuXPosition)("overlapTrigger", ctx_r7.menuOverlapTrigger);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.visibleMenuItems);
} }
let ResponsiveToolbarComponent = class ResponsiveToolbarComponent {
    constructor(el, ngZone, changeDetector) {
        this.el = el;
        this.ngZone = ngZone;
        this.changeDetector = changeDetector;
        this.updatingButtons = false;
        this.menuButtonEnabled = true;
        this.onlyMenu = false;
        this.menuYPosition = 'below';
        this.menuXPosition = 'before';
        this.menuOverlapTrigger = true;
        this.update = this.update.bind(this);
        ngZone.runOutsideAngular(() => {
            this.observer = new MutationObserver(this.update);
            this.observer.observe(this.el.nativeElement, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true,
            });
            this.resizeSubscription = merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange'), fromEvent(window, 'load')).subscribe(this.update);
        });
    }
    get buttons() { return this._buttons; }
    set buttons(buttons) {
        // Store definitions
        this._buttons = buttons.filter(button => button);
        this.allRegularButtons = this._buttons.map(button => button.regularButton);
        this.visibleRegularButtons = [];
        this.updatingButtons = true;
    }
    ngAfterViewChecked() {
        if (this.updatingButtons) {
            this.update();
            this.updatingButtons = false;
        }
    }
    ngDestroy() {
        this.ngZone.runOutsideAngular(() => {
            this.observer && this.observer.disconnect();
            this.resizeSubscription && this.resizeSubscription.unsubscribe();
        });
        if (this.updateTimeout)
            clearTimeout(this.updateTimeout);
    }
    update() {
        const testbed = this.overflowTestBed.nativeElement;
        const elements = testbed.children;
        const testElements = [];
        for (let i = 0; i < elements.length; i++) {
            testElements.push(elements.item(i));
        }
        let amountToShow = 0;
        if (!this.onlyMenu) {
            // Approach 1 - Chose against
            //
            // const testbed: HTMLDivElement = (this.overflowTestBed.nativeElement as HTMLDivElement);
            // const testbedRect: ClientRect = testbed.getClientRects().item(0)!;
            // for (const element of testElements!)
            // {
            //     const rects = element.getClientRects();
            //     if (!rects.length || rects.item(0)!.right > testbedRect.right)
            //         break;
            //     amountToShow++;
            // }
            // Approach 2
            const getElementWidthAndMargin = (element) => {
                const style = element.currentStyle || window.getComputedStyle(element);
                const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
                return element.offsetWidth + margin;
            };
            const getElementWidthMinusPadding = (element) => {
                const style = element.currentStyle || window.getComputedStyle(element);
                const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                return element.offsetWidth - padding;
            };
            const everything = this.everything.nativeElement;
            const everythingWidth = getElementWidthMinusPadding(everything);
            const menuButtonReference = this.menuButtonReference.nativeElement;
            const menuButtonWidth = getElementWidthAndMargin(menuButtonReference);
            let accumulated = menuButtonWidth;
            for (const element of testElements) {
                const elementWidthAndMargin = getElementWidthAndMargin(element);
                if (!isNaN(elementWidthAndMargin))
                    accumulated += elementWidthAndMargin;
                if (accumulated > everythingWidth)
                    break;
                amountToShow++;
            }
            if (amountToShow == testElements.length - 1 && accumulated - menuButtonWidth <= everythingWidth)
                amountToShow++;
        }
        const updatingButtons = this.updatingButtons;
        if (updatingButtons || this.lastCalculatedAmountToShow != amountToShow) {
            this.lastCalculatedAmountToShow = amountToShow;
            if (updatingButtons || !this.updateTimeout)
                this.ngZone.run(() => {
                    this.updateTimeout = setTimeout(() => {
                        if (updatingButtons || this.lastAmountToShow != this.lastCalculatedAmountToShow) {
                            delete this.updateTimeout;
                            this.lastAmountToShow = this.lastCalculatedAmountToShow;
                            this.visibleRegularButtons = this.allRegularButtons.slice(0, this.lastCalculatedAmountToShow);
                            const visibleItemDefinitions = this.buttons.slice(this.lastCalculatedAmountToShow);
                            this.visibleMenuItems = [];
                            for (const definition of visibleItemDefinitions) {
                                if (definition.menuItem) {
                                    let group = definition.menuItemGroup;
                                    if (!group)
                                        group = '---no-group---';
                                    const existingGroup = this.visibleMenuItems.find(a => a.group == group);
                                    if (existingGroup)
                                        existingGroup.items.push(definition.menuItem);
                                    else
                                        this.visibleMenuItems.push({ group, items: [definition.menuItem] });
                                }
                            }
                            this.changeDetector.markForCheck();
                        }
                    }, 0);
                });
        }
    }
    get showMenuButton() { return !!(this.visibleMenuItems && this.visibleMenuItems.length); }
};
ResponsiveToolbarComponent.ɵfac = function ResponsiveToolbarComponent_Factory(t) { return new (t || ResponsiveToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ResponsiveToolbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ResponsiveToolbarComponent, selectors: [["egov-responsive-toolbar"]], viewQuery: function ResponsiveToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overflowTestBed = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.everything = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuButtonReference = _t.first);
    } }, inputs: { menuButtonEnabled: "menuButtonEnabled", onlyMenu: "onlyMenu", menuYPosition: "menuYPosition", menuXPosition: "menuXPosition", menuOverlapTrigger: "menuOverlapTrigger", buttons: "buttons", menuButton: "menuButton", menuClass: "menuClass" }, decls: 14, vars: 5, consts: [[1, "everything"], ["everything", ""], [1, "buttons"], [1, "overflow-test-bed"], ["testBed", ""], [4, "ngFor", "ngForOf"], [1, "actual"], [1, "vertical-space-taker"], [1, "menu-button-click-handler", "reference"], ["menuButtonReference", ""], [4, "ngTemplateOutlet"], [4, "ngIf"], ["class", "menu-button-click-handler", 3, "matMenuTriggerFor", 4, "ngIf"], ["class", "menu-button-click-handler", 4, "ngIf"], [3, "ngClass", "yPosition", "xPosition", "overlapTrigger"], ["toolbarMenu", "matMenu"], [1, "menu-button-click-handler", 3, "matMenuTriggerFor"], [1, "menu-button-click-handler"]], template: function ResponsiveToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "div", 3, 4);
        ɵngcc0.ɵɵtemplate(5, ResponsiveToolbarComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtemplate(7, ResponsiveToolbarComponent_ng_container_7_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtemplate(9, ResponsiveToolbarComponent_ng_container_9_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 8, 9);
        ɵngcc0.ɵɵtemplate(12, ResponsiveToolbarComponent_ng_container_12_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, ResponsiveToolbarComponent_ng_container_13_Template, 6, 7, "ng-container", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.allRegularButtons);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleRegularButtons);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleRegularButtons);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.menuButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMenuButton);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.MatMenu, ɵngcc2.MatMenuTrigger, ɵngcc3.MatDivider], styles: ["egov-responsive-toolbar{display:-webkit-box;display:flex;width:100%;max-width:100%}egov-responsive-toolbar .everything{display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;width:100%;max-width:100%;position:relative}egov-responsive-toolbar .everything .buttons{-webkit-box-flex:1;flex:1 1 0;position:relative}egov-responsive-toolbar .everything .buttons>*{display:-webkit-box;display:flex;flex-wrap:nowrap}egov-responsive-toolbar .everything .buttons>.overflow-test-bed{position:absolute;top:0;left:0;right:0;visibility:hidden;-webkit-box-pack:start;justify-content:flex-start}egov-responsive-toolbar .everything .buttons>.actual{position:absolute;top:0;left:0;right:0;-webkit-box-pack:end;justify-content:flex-end}egov-responsive-toolbar .everything .buttons>.vertical-space-taker{width:0;max-width:0;visibility:hidden}egov-responsive-toolbar .everything .buttons>*>*,egov-responsive-toolbar .everything .buttons>*>*>*{-webkit-box-flex:0;flex:0 0 auto}egov-responsive-toolbar .everything .menu-button-click-handler{pointer-events:none}egov-responsive-toolbar .everything .menu-button-click-handler>*{pointer-events:auto}egov-responsive-toolbar .everything .menu-button-click-handler.reference{position:absolute;top:0;right:0;visibility:hidden}"], encapsulation: 2, changeDetection: 0 });
ResponsiveToolbarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "buttons", null);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuButton", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuButtonEnabled", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "onlyMenu", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuClass", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuYPosition", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuXPosition", void 0);
__decorate([
    Input()
], ResponsiveToolbarComponent.prototype, "menuOverlapTrigger", void 0);
__decorate([
    ViewChild('testBed', { static: true })
], ResponsiveToolbarComponent.prototype, "overflowTestBed", void 0);
__decorate([
    ViewChild('everything', { static: true })
], ResponsiveToolbarComponent.prototype, "everything", void 0);
__decorate([
    ViewChild('menuButtonReference', { static: true })
], ResponsiveToolbarComponent.prototype, "menuButtonReference", void 0);

let ResponsiveToolbarModule = class ResponsiveToolbarModule {
};
ResponsiveToolbarModule.ɵfac = function ResponsiveToolbarModule_Factory(t) { return new (t || ResponsiveToolbarModule)(); };
ResponsiveToolbarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ResponsiveToolbarModule });
ResponsiveToolbarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        MatMenuModule,
        MatDividerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResponsiveToolbarComponent, [{
        type: Component,
        args: [{ selector: 'egov-responsive-toolbar', template: "<div class=\"everything\" #everything>\n    <div class=\"buttons\">\n        <div #testBed class=\"overflow-test-bed\">\n            <ng-container *ngFor=\"let button of allRegularButtons; let index = index\">\n                <ng-container *ngIf=\"button\"><ng-container *ngTemplateOutlet=\"button\"></ng-container></ng-container>\n            </ng-container>\n        </div>\n        <div class=\"actual\">\n            <ng-container *ngFor=\"let button of visibleRegularButtons\">\n                <ng-container *ngIf=\"button\"><ng-container *ngTemplateOutlet=\"button\"></ng-container></ng-container>\n            </ng-container>\n        </div>\n        <div class=\"vertical-space-taker\">\n            <ng-container *ngFor=\"let button of visibleRegularButtons\">\n                <ng-container *ngIf=\"button\"><ng-container *ngTemplateOutlet=\"button\"></ng-container></ng-container>\n            </ng-container>\n        </div>\n    </div>\n    <div class=\"menu-button-click-handler reference\" #menuButtonReference>\n        <ng-container *ngTemplateOutlet=\"menuButton\"></ng-container>\n    </div>\n    <ng-container *ngIf=\"showMenuButton\">\n        <div class=\"menu-button-click-handler\" *ngIf=\"menuButtonEnabled\" [matMenuTriggerFor]=\"toolbarMenu\">\n            <ng-container *ngTemplateOutlet=\"menuButton\"></ng-container>\n        </div>\n        <div class=\"menu-button-click-handler\" *ngIf=\"!menuButtonEnabled\">\n            <ng-container *ngTemplateOutlet=\"menuButton\"></ng-container>\n        </div>\n        <mat-menu\n            #toolbarMenu=\"matMenu\"\n            [ngClass]=\"menuClass\"\n            [yPosition]=\"menuYPosition\"\n            [xPosition]=\"menuXPosition\"\n            [overlapTrigger]=\"menuOverlapTrigger\"\n        >\n            <ng-container *ngFor=\"let group of visibleMenuItems; let index = index\">\n                <ng-container *ngFor=\"let button of group.items\">\n                    <ng-container *ngTemplateOutlet=\"button\"></ng-container>\n                </ng-container>\n                <mat-divider></mat-divider>\n            </ng-container>\n        </mat-menu>\n    </ng-container>\n</div>\n", encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["egov-responsive-toolbar{display:-webkit-box;display:flex;width:100%;max-width:100%}egov-responsive-toolbar .everything{display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;width:100%;max-width:100%;position:relative}egov-responsive-toolbar .everything .buttons{-webkit-box-flex:1;flex:1 1 0;position:relative}egov-responsive-toolbar .everything .buttons>*{display:-webkit-box;display:flex;flex-wrap:nowrap}egov-responsive-toolbar .everything .buttons>.overflow-test-bed{position:absolute;top:0;left:0;right:0;visibility:hidden;-webkit-box-pack:start;justify-content:flex-start}egov-responsive-toolbar .everything .buttons>.actual{position:absolute;top:0;left:0;right:0;-webkit-box-pack:end;justify-content:flex-end}egov-responsive-toolbar .everything .buttons>.vertical-space-taker{width:0;max-width:0;visibility:hidden}egov-responsive-toolbar .everything .buttons>*>*,egov-responsive-toolbar .everything .buttons>*>*>*{-webkit-box-flex:0;flex:0 0 auto}egov-responsive-toolbar .everything .menu-button-click-handler{pointer-events:none}egov-responsive-toolbar .everything .menu-button-click-handler>*{pointer-events:auto}egov-responsive-toolbar .everything .menu-button-click-handler.reference{position:absolute;top:0;right:0;visibility:hidden}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ChangeDetectorRef }]; }, { menuButtonEnabled: [{
            type: Input
        }], onlyMenu: [{
            type: Input
        }], menuYPosition: [{
            type: Input
        }], menuXPosition: [{
            type: Input
        }], menuOverlapTrigger: [{
            type: Input
        }], buttons: [{
            type: Input
        }], menuButton: [{
            type: Input
        }], menuClass: [{
            type: Input
        }], overflowTestBed: [{
            type: ViewChild,
            args: ['testBed', { static: true }]
        }], everything: [{
            type: ViewChild,
            args: ['everything', { static: true }]
        }], menuButtonReference: [{
            type: ViewChild,
            args: ['menuButtonReference', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResponsiveToolbarModule, [{
        type: NgModule,
        args: [{
                declarations: [ResponsiveToolbarComponent],
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatDividerModule,
                ],
                exports: [ResponsiveToolbarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ResponsiveToolbarModule, { declarations: function () { return [ResponsiveToolbarComponent]; }, imports: function () { return [CommonModule,
        MatMenuModule,
        MatDividerModule]; }, exports: function () { return [ResponsiveToolbarComponent]; } }); })();

/*
 * Public API Surface of angular-responsive-toolbar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ResponsiveToolbarComponent, ResponsiveToolbarModule };

